import { borderStyles, borderWidths } from './borders.js';
import { breakpoints, mediaQueries } from './breakpoints.js';
import { colors } from './colors.js';
import { debounceTime } from './debounce.js';
import { throttleTime } from './throttle.js';
import { opacity } from './opacity.js';
import { outlines } from './outlines.js';
import { radii } from './radius.js';
import { shadows } from './shadows.js';
import { sizes } from './sizing.js';
import { space } from './spacing.js';
import { styles } from './styles/index.js';
import { transitions } from './transition.js';
import { fonts, fontSizes, fontWeights, letterSpacings, lineHeights, textDecorationThicknesses, textDecorationLines, } from './typography.js';
import { zIndices } from './z-index.js';
import * as helpers from './helpers.js';
export const theme = {
    borderStyles,
    borderWidths,
    breakpoints,
    colors,
    debounceTime,
    throttleTime,
    fontSizes,
    fontWeights,
    fonts,
    letterSpacings,
    lineHeights,
    mediaQueries,
    opacity,
    outlines,
    radii,
    shadows,
    sizes,
    space,
    styles,
    textDecorationThicknesses,
    textDecorationLines,
    transitions,
    zIndices,
    helpers,
};
//# sourceMappingURL=index.js.map